import { Component, Input, OnInit } from '@angular/core';
import { ReportConstants } from '../../../admin/services/template.service';

@Component({
    selector: 'app-multiline-translation',
    templateUrl: './multiline-translation.component.html',
    styleUrls: ['./multiline-translation.component.scss'],
    standalone: false
})
export class MultilineTranslationComponent implements OnInit {
  @Input() text: string;

  get lines(): string[] {
    if (!this.text) return [''];
    let lines = this.text.split('\n');
    let employeeDrinkingWithCategory = lines.find(l => l.includes(ReportConstants.EmployeeDrinking));
    if (employeeDrinkingWithCategory) {
      lines = lines.filter(x => x !== employeeDrinkingWithCategory);
      let category = employeeDrinkingWithCategory.replace(ReportConstants.EmployeeDrinking, '').trim();
      lines.push(ReportConstants.EmployeeDrinking, category);
    }
    return lines;
  }

  constructor() {}

  ngOnInit(): void {}

  isEmployeeDrinking(line: string) {
    return (
      line.includes(ReportConstants.EmployeeDrinking) || (this.lines.length === 2 && this.lines[0] === ReportConstants.EmployeeDrinking)
    );
  }
}
